import {z} from 'zod';

/**
 * Schema for GET /list request query parameters
 */
export const getListPromptsRequestSchema = z.object({
  useCaseType: z.string().optional(),
  createdBy: z.string().optional(),
  limit: z.coerce.number().int().positive().max(100).optional().default(20),
  offset: z.coerce.number().int().nonnegative().optional().default(0),
});
